<h4 class="title">Authorizations List</h4>
<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt>
    <ng-template pTemplate="header">
            <tr style="text-align: center;" class="thhead">
                <th>CUSTOMER NO</th>
                <th>TOTAL NO OF CONTRACT</th>
                <th>LOAN AMOUNT</th>
                <th>PROTFOLIO</th>
                <th>PRODUCT</th>
                <th>GROUP</th>
                <th>COLLECTOR</th>
                <th>WORKFLOW</th>
                <th>STATE</th>
            </tr>
              <tr>
                <th>546</th>
                <th>2</th>
                <th>123456213</th>
                <th>HOME LOAN</th>
                <th>AUTO</th>
                <th>GROUP</th>
                <th>NIKHIL</th>
                <th>TELE</th>
                <th>BP</th>
              </tr>
    </ng-template>
 </p-table>  </div>


<div class="row" style="padding: 20px;">
  <div class="col-md-12" style="background: white;border: 1px solid;">
     <div class="row" style="padding: 10px;">
       <div class="col-md-2">
        <button>Supervisory</button>
       </div>
       <div class="col-md-2">
        <button>Authorization</button>
       </div>
     </div>



     <div class="row" style="padding: 10px;">
      <div class="row">
        <div class="col-md-12">
        Authorization Details
         </div>
      </div>
      <div class="row">
        <div class="col-md-12">
        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt>
          <ng-template pTemplate="header">
                  <tr style="text-align: center;" class="thhead">
                      <th><input type="checkbox"></th>
                      <th>Authorization type</th>
                      <th>Requested Date</th>
                      <th>Requested by</th>
                      <th>Multi auth type</th>
                      <th>count of Done</th>
                      <th>count of Req</th>
                  </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
          </ng-template>
       </p-table>  </div>
    </div>
      </div>
    </div>



    <div class="row" style="padding: 10px;">
      <div class="row">
        <div class="col-md-12">
        Authorization type :
         </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
        <div class="col-md-3">
        <input type="radio" id="male" name="gender" value="male">
        <label for="male" style="padding-left:10px;"> Recommend </label><br>
      </div>

        <div class="col-md-3">
        <input type="radio" id="female" name="gender" value="female">
        <label for="female" style="padding-left:10px;"> Revert </label><br>
        </div>

        <div class="col-md-3">
        <input type="radio" id="other" name="gender" value="other">
        <label for="other" style="padding-left:10px;" > Reject</label>
      </div>

        <div class="col-md-3">
        <input type="radio" id="other1" name="gender" value="other1">
        <label for="other1" style="padding-left:10px;"> Approve</label>
        </div>
    </div>
  </div>
    </div>


    <div class="row" style="padding: 10px;">
      <div class="row">
        <div class="col-md-12">
        Note :
         </div>
      </div>
    </div>

    <div class="row" style="padding: 10px;">
      <div class="row">
        <div class="col-md-12">
        <textarea type="text" style="width: 500px;height: 200px;"></textarea>
        </div>
      </div>
      </div>



  </div>
</div>



<div class="row" style="padding: 20px;">
  <div class="col-md-12" style="background: white;border: 1px solid; padding: 10px;">
  <div class="col-md-9">
  </div>
  <div class="col-md-1">
    <button class="btn btn-primary mr-0">Save</button>
  </div>
  <div class="col-md-1">
    <button class="btn btn-primary mr-0">Close</button>
  </div>
  <div class="col-md-1">
    <button class="btn btn-primary mr-0">Next</button>
  </div>
  </div>
</div>
